// extracted by mini-css-extract-plugin
module.exports = {"profileButton":"ProfileButton_profileButton__3VYf4","primary":"ProfileButton_primary__3c_tW","fullWidth":"ProfileButton_fullWidth__3vDfY"};